import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './ClaimLayoutNameField.module.scss';

const ClaimLayoutNameField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.claimLayoutNameField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.claimLayoutNameId}>
          {credentialForm.claimLayoutNameLabel}
        </Label>
        <TextField
          id={credentialForm.claimLayoutNameId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

ClaimLayoutNameField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

ClaimLayoutNameField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default ClaimLayoutNameField;
